/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_Col_TypeInputs */

const vi_customer_debt_ledger_col_type = /** @type {(inputs: Customer_Debt_Ledger_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

/**

* @param {Customer_Debt_Ledger_Col_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_col_type = /** @type {((inputs?: Customer_Debt_Ledger_Col_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_Col_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_col_type(inputs)
});